import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import webservice from '../../../../services/webservice'
import { AesDecrypt, AesEncrypt } from '../../../../services/crypto';


// export const getbloodData = createAsyncThunk('dashboard/getbloodData', async (data) => {
//     const Encparams = AesEncrypt(data);
//     try {
//         const response = await fetch(webservice + 'api/getbloodData', {

//             method: 'POST',
//             body: JSON.stringify({ Encparams }), // Pass the entire data object directly
//             headers: {
//                 'Content-type': 'application/json; charset=UTF-8',
//             }
//         });
//         const responseData = await response.json();
//         return responseData;
//     } catch (error) {
//         console.error('Error:', error);
//         throw error; // Rethrow the error to be handled by Redux Toolkit
//     }
// })
// export const getbloodsugarlevel = createAsyncThunk('dashboard/getbloodsugarlevel', async (data) => {
//     const Encparams = AesEncrypt(data);
//     try {
//         const response = await fetch(webservice + 'api/getBloodsugarLevel', {

//             method: 'POST',
//             body: JSON.stringify({ Encparams }), // Pass the entire data object directly
//             headers: {
//                 'Content-type': 'application/json; charset=UTF-8',
//             }
//         });
//         const responseData = await response.json();
//         return responseData;
//     } catch (error) {
//         console.error('Error:', error);
//         throw error; // Rethrow the error to be handled by Redux Toolkit
//     }
// })
// export const getmooddata = createAsyncThunk('dashboard/getmooddata', async (data) => {
//     const Encparams = AesEncrypt(data);
//     try {
//         const response = await fetch(webservice + 'api/getMoodData', {

//             method: 'POST',
//             body: JSON.stringify({ Encparams: Encparams }), // Pass the entire data object directly
//             headers: {
//                 'Content-type': 'application/json; charset=UTF-8',
//             }
//         });
//         const responseData = await response.json();
//         return responseData;
//     } catch (error) {
//         console.error('Error:', error);
//         throw error; // Rethrow the error to be handled by Redux Toolkit
//     }
// })


// export const getBmi = createAsyncThunk('dashboard/getBmi', async (data) => {
//     const Encparams = AesEncrypt(data);
//     try {
//         const response = await fetch(webservice + 'api/getBmi', {

//             method: 'POST',
//             body: JSON.stringify({ Encparams }), // Pass the entire data object directly
//             headers: {
//                 'Content-type': 'application/json; charset=UTF-8',
//             }
//         });
//         const responseData = await response.json();
//         return responseData;
//     } catch (error) {
//         console.error('Error:', error);
//         throw error; // Rethrow the error to be handled by Redux Toolkit
//     }
// })


export const getbloodsugarchart = createAsyncThunk('dashboard/getbloodsugarchart', async (data) => {
    const Encparams = AesEncrypt(data);
    try {
        const response = await axios.post(webservice + 'api/getBloodsugarChart', { Encparams });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}
);

export const getbloodpresurechartData = createAsyncThunk('dashboard/getbloodpresurechartData', async (data) => {
    const Encparams = AesEncrypt(data);
    try {
        const response = await axios.post(webservice + 'api/getBloodpresureChart', { Encparams });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}
);
export const getstepcount = createAsyncThunk('dashboard/getstepcount', async (data) => {
    const requestData = { userId: data };
    const Encparams = AesEncrypt(requestData);
    try {
        const response = await axios.post(webservice + 'api/getStepCount', { Encparams });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const getstep = createAsyncThunk('dashboard/getstep', async (data) => {
    const requestData = { userId: data };
    const Encparams = AesEncrypt(requestData);
    try {
        const response = await axios.post(webservice + 'api/getStep', { Encparams });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

export const getstepChart = createAsyncThunk('dashboard/getstepChart', async (data) => {
    const requestData = { userId: data };
    const Encparams = AesEncrypt(requestData);
    try {
        const response = await axios.post(webservice + 'api/getstepChart', { Encparams });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
});

// Add Step
export const Setstep = createAsyncThunk('profile/Addstep', async (data) => {
    const Encparams = AesEncrypt(data);
    const response = await axios.post(webservice + 'api/addStep', { Encparams });
    return response.data;
})

export const getuserdata = createAsyncThunk('Dashboard/getuserdata', async () => {
    const response = await axios.get(webservice + 'api/getuserdata');
    return response.data;
})



// export const blooddonate = createAsyncThunk('Dashboard/blooddonate', async () => {
//     const response = await fetch(webservice + 'api/blooddonate', {
//          method: 'GET',
//          headers: {
//               'Content-type': 'application/json; charset=UTF-8',
//          },
//     })
//          .then((response) => response.json())
//     return response;
// })
// export const Moodmonitor = createAsyncThunk('Dashboard/Moodmonitor', async () => {
//     const response = await fetch(webservice + 'api/Moodmonitor', {
//          method: 'GET',
//          headers: {
//               'Content-type': 'application/json; charset=UTF-8',
//          },
//     })
//          .then((response) => response.json())
//     return response;
// })
// export const documentuploades = createAsyncThunk('Dashboard/documentuploades', async () => {
//     const response = await fetch(webservice + 'api/documentuploades', {
//          method: 'GET',
//          headers: {
//               'Content-type': 'application/json; charset=UTF-8',
//          },
//     })
//          .then((response) => response.json())
//     return response;
// })
// export const Bloodpressure = createAsyncThunk('Dashboard/Bloodpressure', async () => {
//     const response = await fetch(webservice + 'api/Bloodpressure', {
//          method: 'GET',
//          headers: {
//               'Content-type': 'application/json; charset=UTF-8',
//          },
//     })
//          .then((response) => response.json())
//     return response;
// })
// export const bloodsugar = createAsyncThunk('Dashboard/bloodsugar', async () => {
//     const response = await fetch(webservice + 'api/bloodsugar', {
//          method: 'GET',
//          headers: {
//               'Content-type': 'application/json; charset=UTF-8',
//          },
//     })
//          .then((response) => response.json())
//     return response;
// })



export const fetchDashboardData = createAsyncThunk('Dashboard/fetchDashboardData', async () => {
    const response = await axios.get(webservice + 'api/dashboard-data');
    return response.data;
});

// Fetch dashboard statistics counts (Total Users, Period Tracking, Blood Pressure, Mood Logs)
// Fetch module usage statistics
export const fetchModuleUsageStats = createAsyncThunk('Dashboard/fetchModuleUsageStats', async () => {
    const response = await axios.get(webservice + 'api/module-usage-stats');
    return response.data;
});

export const fetchTotalUsers = createAsyncThunk('Dashboard/fetchTotalUsers', async () => {
    const response = await axios.get(webservice + 'api/module-usage-total-counts');
    return response.data;
});

export const fetchDashboardStats = createAsyncThunk('Dashboard/fetchDashboardStats', async () => {
    const response = await axios.get(webservice + 'api/dashboard-stats');
    return response.data;
});

// Fetch gender distribution for bar chart
// Fetch gender distribution for bar chart
export const fetchGenderDistribution = createAsyncThunk('Dashboard/fetchGenderDistribution', async (location = '') => {
    const response = await axios.post(webservice + 'api/gender-distribution', {
        location: location || ''
    });
    return response.data;
});

// Fetch feature usage by gender for grouped bar chart (with optional location filter)
export const fetchFeatureUsageByGender = createAsyncThunk('Dashboard/fetchFeatureUsageByGender', async (location = '') => {
    const response = await axios.post(webservice + 'api/feature-usage-by-gender', {
        location: location || ''
    });
    return response.data;
});

// Fetch user locations for dropdown
export const fetchUsersLocation = createAsyncThunk('Dashboard/fetchUsersLocation', async () => {
    const response = await axios.get(webservice + 'api/users-location');
    return response.data;
});

// Fetch water intake stats for chart
export const fetchWaterIntakeStats = createAsyncThunk('Dashboard/fetchWaterIntakeStats', async () => {
    const response = await axios.get(webservice + 'api/water-intake-stats');
    return response.data;
});

// Fetch main focus distribution for chart
export const fetchMainFocusDistribution = createAsyncThunk('Dashboard/fetchMainFocusDistribution', async () => {
    const response = await axios.get(webservice + 'api/main-focus-distribution');
    return response.data;
});

// Fetch steps tracker stats by gender
export const fetchStepsTrackerStats = createAsyncThunk('Dashboard/fetchStepsTrackerStats', async (timeframe = 'daily') => {
    const response = await axios.post(webservice + 'api/steps-tracker-stats', { timeframe });
    return response.data;
});

// Fetch detailed blood pressure report
export const fetchBloodPressureReport = createAsyncThunk('Dashboard/fetchBloodPressureReport', async (filters = {}) => {
    const response = await axios.post(webservice + 'api/blood-pressure-report', filters);
    return response.data;
});

// Fetch detailed blood sugar report
export const fetchBloodSugarReport = createAsyncThunk('Dashboard/fetchBloodSugarReport', async (filters = {}) => {
    const response = await axios.post(webservice + 'api/blood-sugar-report', filters);
    return response.data;
});

// Fetch detailed mood report
export const fetchMoodReport = createAsyncThunk('Dashboard/fetchMoodReport', async (filters = {}) => {
    const response = await axios.post(webservice + 'api/mood-report', filters);
    return response.data;
});
